/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IState } from '../store/types/StateTypes';
import datasetTypes from '../enums/datasetTypes';
import DataState from '../enums/DataState';

interface ISampleDataServiceComponentProperties {
    visualization: any,
    data: any,
    controlsDataLoading: boolean
    staticProperties: any,
    dynamicProperties: any,
    levelsLayout: any,
    dataState: string,
    dataError: null | any,
    deferredAction: JQuery.Deferred<any>
}

class SampleDataServiceComponentUnconnected
    extends Component<ISampleDataServiceComponentProperties, never> {

    componentDidMount(): void {
        this.resolveDeferredAction();
    }

    componentDidUpdate(prevProps: Readonly<ISampleDataServiceComponentProperties>, prevState: Readonly<never>, snapshot?: any): void {
        this.resolveDeferredAction();
    }

    resolveDeferredAction() {
        const { dataState, dataError, deferredAction } = this.props;

        if (dataState === DataState.LOADED) {
            deferredAction.resolve();
        } else if (dataState === DataState.ERROR) {
            deferredAction.reject(dataError);
        }
    }

    render() {
        const { visualization: Visualization } = this.props;
        const { data, staticProperties, dynamicProperties } = this.props;

        return (
            <Visualization
                dataset={data}
                staticProperties={staticProperties}
                dynamicProperties={dynamicProperties}
                handle={{ doSomething: () => {} }}
            />
        );
    }
}

const mapStateToProps = (state: IState) => ({
    levelsLayout: state.levelsLayout,
    data: state.data[datasetTypes.SAMPLE],
    staticProperties: state.visualization[state.visualizationDescriptor.name].staticProperties,
    dynamicProperties: state.visualization[state.visualizationDescriptor.name].dynamicProperties,
    dataState: state.dataState,
    dataError: state.dataError,
    deferredAction: state.deferredAction
});

const mapDispatchToProps = () => ({});

const connectFn = connect(mapStateToProps, mapDispatchToProps);
const SampleDataServiceComponent = connectFn(SampleDataServiceComponentUnconnected);

export {
    SampleDataServiceComponent,
    SampleDataServiceComponentUnconnected,
    mapDispatchToProps,
    mapStateToProps
};
